






import {Component, Mixins, Prop} from 'vue-property-decorator';
import InputMixin from '@/components/input/InputMixin';
import {Editor} from '@tiptap/vue-2';
import TooltipIconButton from '@/components/button/TooltipIconButton.vue';

@Component({
             components: {TooltipIconButton},
             mixins: [InputMixin]
           })
export default class EditorMakeTableButton extends Mixins<InputMixin>(InputMixin) {
  @Prop({default: null}) private editor: Editor;

  /**
   * table안의 table 중복 생성을 방지하기 위함.
   * table인지 아닌지 여부를 알려주는 마땅한 함수가 없어 table 삭제가 가능한지 아닌지로 여부 판단함.
   */
  get isDisabled() {
    return this.editor.can().deleteTable();
  }

  private handleClick() {
    this.$modal.showMakeEditorTableDialog({
      onConfirm: (rows: number, columns: number, isWithHeaderRow: boolean) => {
        this.editor.chain().focus().insertTable({
                                                  rows,
                                                  cols: columns,
                                                  withHeaderRow: isWithHeaderRow
                                                }).run();
      }
    });
  }
}
